import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// DELETE an instruction
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestDeleteInstruction = packet => {
  return {
    type: 'REQUEST_DELETE_INSTRUCTION',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveDeleteInstructionSuccess = data => ({
  type: 'RECEIVE_DELETE_INSTRUCTION_SUCCESS',
  data
})

export const receiveDeleteInstructionFail = data => ({
  type: 'RECEIVE_DELETE_INSTRUCTION_FAIL',
  data
})

export const tryToDeleteInstruction = packet => (dispatch, getState) => {

  dispatch(requestDeleteInstruction(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/instructions/' + packet.id, {
      method: 'delete',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      // dispatch(push('/workbench/' + packet.scope));
      dispatch(receiveDeleteInstructionSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveDeleteInstructionFail({errors:e, lastSubmit: packet}));
    })
}
